import "bootstrap/dist/css/bootstrap.min.css";

import { Container, Row, Col } from "react-bootstrap";

function Yeongyeong() {
  return (
    <Container className="mt-3 mb-3">
      <Row>
        <Col>
          <img
            alt="이미지"
            style={{ width: "100%", borderRadius: "1rem" }}
            src="/yeongyeong/yg1.jpg"
          />
        </Col>
        <Col>
          <img
            alt="이미지"
            style={{ width: "100%", borderRadius: "1rem" }}
            src="/yeongyeong/yg2.jpg"
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <img
            alt="이미지"
            style={{ width: "100%", borderRadius: "1rem" }}
            src="/yeongyeong/main.jpg"
          />
        </Col>
        <Col>
          <img
            alt="이미지"
            style={{ width: "100%", borderRadius: "1rem" }}
            src="/yeongyeong/yg2.jpg"
          />
        </Col>
        <Col>
          <img
            alt="이미지"
            style={{ width: "100%", borderRadius: "1rem" }}
            src="/yeongyeong/yg2.jpg"
          />
        </Col>
      </Row>
    </Container>
  );
}

export default Yeongyeong;
